import { useAppContexts } from "hooks/use-context";
import GroupsLite from "./groups-lite";
import Groups from "./groups";
import { TIER3 } from "../../../constants";

type GroupsProps = {
  type: string;
};

function GroupsList({ type }: GroupsProps) {
  const { program } = useAppContexts();
  return program?.isLite && program.tier !== TIER3 ? <GroupsLite type={type} /> : <Groups type={type} />;
}

export default GroupsList;
